export default [
    {
        path: "/mensagens-lua",
        name: "Mensagens Lua",
        component: () => import("../views/Mensagenslua"),
        meta: { requiresAuth: true },
    },
];
